import $ from 'jquery';

let isLoading;

module.exports = {
  isMobile() {
    return /Mobile|Android|Silk\/|Kindle|BlackBerry|Opera Mini|Opera Mobi|webOS/i.test( navigator.userAgent );
  },

  showLoading() {
    if(!isLoading) {
      isLoading = true;
      $('body').append('<div id="loading"><i class="fa fa-spinner"></i></div>');
    }
  },

  hideLoading() {
    isLoading = false;
    $('#loading').remove();
  },

  numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  /**
   * Throttle
   * use to limit function calls so we don't kill something.
   * https://remysharp.com/2010/07/21/throttling-function-calls
   */
  throttle(func, delay) {
    var last, timer;

    return function() {
      var context = this;
      var now     = new Date;
      var args    = arguments;

      if(last && now < last + delay) {
        clearTimeout(timer);
        timer = setTimeout(function() {
          last = now;
          func.apply(context, args);
        }, delay);
      } else {
        last = now;
        func.apply(context, args);
      }
    }
  }
};





// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/utils.js